import React from 'react';
import './style.scss';

interface ChatbotResponseMessageBubbleProps {
    /** The chatbot's response text (e.g. welcome message from start-session) */
    text: string;
}

const ChatbotResponseMessageBubble: React.FC<ChatbotResponseMessageBubbleProps> = ({ text }) => {
    return (
        <div className="chatbot-response-message-row">
            <div className="chatbot-response-message-bubble">
                <span className="chatbot-response-message-text">{text}</span>
            </div>
        </div>
    );
};

export default ChatbotResponseMessageBubble;
